<template>
  <div v-loading="showLoadingIcon && loading" class="data-load-wrap">
    <slot />
  </div>
</template>
<script lang="ts">
import "./style.scss";
import findInfoData, { findInfoProps } from "../../commonMix/findInfoData";
import type { FindInfoOperateType } from "../../commonMix/findInfoData/types";
import { defineComponent, watch, reactive } from "vue";
import type { ExtractPropTypes, SetupContext } from "vue";
import { cloneDeep, isEqual } from "lodash-es";

export type DataLoadType = FindInfoOperateType;

const DataLoadProps = {
  ...findInfoProps,
  showLoadingIcon: {
    type: Boolean,
    default: true,
  },
};
export type DataLoadPropsType = ExtractPropTypes<typeof DataLoadProps>;
export default defineComponent({
  name: "DataLoad",
  props: DataLoadProps,
  // emits: ["success", "error", "update:modelValue", "changeInfoData", "change"],
  setup(props: DataLoadPropsType, ctx: SetupContext<any>) {
    let { loading, findInfoState, stateFetchData, loadData } = findInfoData(
      props,
      ctx,
      (d: any): void => {
        console.log(d);
        ctx.emit("success", d);
      },
      (e: Error): void => {
        console.log(e);
        ctx.emit("error", e);
      }
    );

    watch(
      () => props.modelValue,
      (newValue: any) => {
        if (!isEqual(findInfoState.infoData, newValue)) {
          findInfoState.infoData = cloneDeep(newValue);
        }
      }
    );
    watch(
      () => findInfoState.infoData,
      (newValue: any) => {
        ctx.emit("update:modelValue", findInfoState.infoData);
        ctx.emit("data-change", findInfoState.infoData);
        ctx.emit("changeInfoData", newValue);
      }
    );

    return {
      loading,
      findInfoState,
      stateFetchData,
      loadData,
    };
  },
});
</script>
